<template>
  <q-layout view="hHh Lpr fFf">
    <Header
      @clickLeftDrawer="leftDrawerOpen = !leftDrawerOpen"
      @changeMenu="changeMenu"
    />

    <q-drawer
      v-model="leftDrawerOpen"
      show-if-above
      bordered
      content-class="bg-grey-2"
    >
      <my-menu :router="menuList" :initLevel="0" />
    </q-drawer>

    <q-page-container>
      <!-- <HelloWorld /> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
      </keep-alive>
      <!-- :key="$route.fullPath"解决转跳路由到相同组件不刷新问题 -->
      <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" />
    </q-page-container>

    <q-footer elevated class="bg-grey-8 text-white">
      <q-toolbar>
        <q-toolbar-title style="text-align:center;text-font:16px">
          <q-avatar>
            <img src="https://cdn.quasar.dev/logo/svg/quasar-logo.svg" />
          </q-avatar>
          上海屿倩商贸有限公司
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>

<script>
/* import HelloWorld from '@/components/HelloWorld.vue' */
import Header from "@/components/header.vue";
import Menu from "@/components/menu.vue";
import { getUserMenu } from "@/api/common/user.js";
export default {
  name: "LayoutDefault",

  components: {
    /* HelloWorld, */
    Header,
    MyMenu: Menu,
  },

  data() {
    return {
      leftDrawerOpen: false,
      menuList: [],
    };
  },
  created() {
    this.changeMenu(6);
  },
  methods: {
    changeMenu(parentId) {
      var self = this;
      getUserMenu(parentId).then(function (response) {
        if (response.data.errorCode == "00000") {
          self.menuList = response.data.data;
        } else {
          self.$message.error(response.data.errorMsg);
        }
      });
    },
  },
};
</script>

<style>
</style>
